<template>
  <div class="content-sty">
    <div v-for="(item,index) in dataList" :key="index">
      <van-card>
        <template #thumb>
          <van-image
              width="80"
              height="80"
              :src="item.avatarName"
          />
        </template>
        <template #title>
          <div style="padding-left: 10px;padding-top: 5px;font-weight: bold;font-size: 16px">{{ item.auth === "1" ? item.realName : item.nickName }}</div>
        </template>
        <template #desc>
          <div style="padding-left: 20px;padding-top: 10px">{{ item.city }}</div>
        </template>
        <template #tags>
          <div>
            <div style="padding-left: 10px;padding-top: 10px;font-weight: bold">{{ item.motto }}</div>
          </div>
        </template>
        <template #num>
          <div>
            <div>{{ item.auth === "1" ? "已认证" : "未认证" }}</div>
          </div>
        </template>
      </van-card>
    </div>
  </div>
</template>
<script>
import URL from "@/api/api";

export default {
  data() {
    return {
      dataList: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let userId = localStorage.getItem("userid");
      this.$fetchGet(URL.getAgentList.url, {userId: userId}).then(res => {
        this.dataList = res.data.data
      })
    },
  }
};
</script>

<style lang="less">

</style>
